import React from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { ERROR_MESSAGES } from '../../../common/constants';

interface IProps {
  text: string;
  copied: boolean;
  setCopied: React.Dispatch<React.SetStateAction<boolean>>;
}

const CopyInputField = ({ text, copied, setCopied }: IProps) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      })
      .catch((err) => console.error(ERROR_MESSAGES.FAILED_TO_COPY, err));
  };

  return (
    <div className='copyfiled-btn'>
      <InputGroup>
        <Form.Control
          type='text'
          value={text}
          readOnly
          className='left-rounded'
          style={{ fontStyle: 'italic' }}
        />
        <Button onClick={handleCopy}>{copied ? 'Copied!' : 'Copy'}</Button>
      </InputGroup>
    </div>
  );
};

export default CopyInputField;
